<div class="app-view-container">
  <div class="main-actions">
    <!-- User Avatar and upload button -->
    <div class="user-avatar-box actions-container">
      <thehubz-user-avatar class="flex" [userData]="userData" [isOtherUser]="isOtherUser" [userId]="userId"></thehubz-user-avatar>
    </div>
  </div>

  <div class="app-content-container">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <!-- User personal information -->
      <div class="flex flex-col justify-left border-gray-300 rounded-xl p-6 row-span-1 xl:row-span-3 lg:col-span-4 xl:col-span-1 md:col-span-2 col-span-3 widget-bg-color">
        <thehubz-user-personal-information [userData]="userData" [isOtherUser]="isOtherUser" [userId]="userId"></thehubz-user-personal-information>
      </div>
      <!-- User availability -->
      <div *ngIf="AnyUserProfile | can : 'availability.access'" class="flex flex-col justify-left border-gray-300 rounded-xl p-6 xl:col-span-3 lg:col-span-4 md:col-span-2 col-span-3 widget-bg-color">
        <thehubz-user-availability [userData]="userData" [isOtherUser]="isOtherUser" [userId]="userId"></thehubz-user-availability>
      </div>
      <!-- User vacations -->
      <div
        *ngIf="AnyUserProfile | can : 'vacation.access'"
        class="flex flex-col justify-left border-gray-300 rounded-xl p-6 xl:col-span-3 lg:col-span-4 md:col-span-2 col-span-3 xl:row-span-2 widget-bg-color h-[626px]"
      >
        <thehubz-user-vacations [userData]="userData" [isOtherUser]="isOtherUser" [userId]="userId"></thehubz-user-vacations>
      </div>
    </div>
  </div>
</div>
